import { render } from "./DeliveryWebhookBlock.vue?vue&type=template&id=755d0e42"
import script from "./DeliveryWebhookBlock.vue?vue&type=script&lang=js"
export * from "./DeliveryWebhookBlock.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__